import React from 'react'

type Props = {
    className?  : string

    label?      : string
    children?   : any
}

export default function CustomView_rowComponent(props: Props) {

    const classes = Classes("row", props.className)

    return (
        <div className={classes}>
            <div className="label">{props.label}</div>
            <div className="element">
                {props.children}
            </div>
        </div>
    )
}